import Button from './button';

export default (props) => {
    const { children } = props;

    return <Button { ...props } className="button--change" icon='change'>{ children ? children : 'Change' }</Button>
}